import FinancialVerification from './FinancialVerification/FinancialVerification';
import useRouteStatus from '../../../hooks/useRouteStatus';
import ProgressBars from '../../shared/ProgressBars';
import Support from '../../shared/Support';

export default function FinancialVerificationPage({ location }) {
  useRouteStatus(location);

  return (
    <div role="main" className="mx-6 sm:mx-auto">
      <ProgressBars />
      <div className="mt-4 text-2xl sm:text-4xl font-extrabold">
        Just a few more things
      </div>
      <div className="tracking-wide mb-4 font-light sm:text-lg">
        We just need a little more information from you to make a decision on
        your application.
      </div>
      <div className="tracking-wide mb-4 font-light sm:text-lg">
        Please provide the following information:
      </div>
      <FinancialVerification />
      <div className="mt-6">
        <Support />
      </div>
    </div>
  );
}
